import './table.css'
import MUIDataTable from "mui-datatables";


   
  
   
   
   const styles = theme => ({
    root: {
      flexGrow: 1
    },
    tableWrapper: {
      overflowX: 'auto',
      '& table': {
        minWidth: 650,
      },
      '& th, & td': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  })
  

const table =({data,columns})=>{

   const options = {
    onRowClick:rowData => console.log("komal")
   }
    return (

        <MUIDataTable  
        title={"Employee List"}
        data={data}
        columns={columns}
        options={options}
      
      />
      

    )
}


export default (table);